import { defineComponent as _defineComponent } from 'vue'
import { useMap } from '../mapbox/context'
import { onBeforeMount, onUnmounted, provide, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VectorTileSource',
  props: {
    sourceId: null,
    url: { default: '' }
  },
  setup(__props: any) {

const props = __props as { sourceId: string, url: string }

const { map } = useMap()



const setSourceUrl = (url?: string) => {
  const source = map.value.getSource(props.sourceId)
  if (source && source.type === 'vector' && url) {
    source.setUrl(url)
  } else {
    map.value.addSource(props.sourceId, {
      type: 'vector',
      url: url,
    })
  }
}

onBeforeMount(() => {
  setSourceUrl(props.url)
})

watch(() => props.url, setSourceUrl)

onUnmounted(() => {
  map.value.removeSource(props.sourceId)
})

provide('source', props.sourceId)

return { __sfc: true,map, props, setSourceUrl }
}

})